import {
  Box,
  Card,
  Grid,
  Typography,
  IconButton,
  LinearProgress,
  Alert,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useEffect, useState } from "react";
import YoutubeEmbed from "../../../blog/components/YoutubeEmbed";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination";
import usePostData from "../../../utility/usePostData";

const ListeYoutubeVideo = () => {
  const { data, isLoading, error, paginate, refreshSearch } =
    useFetchDataWithPagination("youtube_medias");
  const [youtubes, setYoutubes] = useState(null);
  const { submitData } = usePostData();

  useEffect(() => {
    if (data?.data) {
      setYoutubes(data?.data.data);
    }
  }, [data]);

  const deleteMedia = (id) => {
    const response = window.confirm("êtes-vous sûr ? ");

    if (response) {
      submitData("youtube_medias/" + id, null, "DELETE");
      refreshSearch();
    }
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography
        variant="h6"
        sx={{
          color: "#00a652",
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <YouTubeIcon /> Liste des Vidéos
      </Typography>

      {isLoading && (
        <LinearProgress
          sx={{
            backgroundColor: "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#00a652",
            },
          }}
        />
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Une erreur est survenue
        </Alert>
      )}

      <Grid container spacing={3}>
        {youtubes &&
          youtubes.map((youtube, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  "&:hover": {
                    transform: "translateY(-4px)",
                    transition: "transform 0.2s ease-in-out",
                  },
                }}
              >
                <Box sx={{ position: "relative" }}>
                  <YoutubeEmbed embedId={youtube.youtube_media} />
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mt: 1,
                      color: "text.secondary",
                      minHeight: "40px",
                    }}
                  >
                    {youtube.youtube_title}
                  </Typography>
                  <IconButton
                    onClick={() => deleteMedia(youtube.id)}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      backgroundColor: "rgba(236,26,32,0.9)",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#ec1a20",
                      },
                      width: 32,
                      height: 32,
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Paper>
            </Grid>
          ))}
      </Grid>

      {youtubes && youtubes.length > 0 && (
        <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
          {paginate()}
        </Box>
      )}

      {youtubes && youtubes.length === 0 && (
        <Typography
          textAlign="center"
          sx={{
            color: "text.secondary",
            mt: 4,
          }}
        >
          Aucune vidéo disponible
        </Typography>
      )}
    </Box>
  );
};

export default ListeYoutubeVideo;
